<bn-loading-overlay></bn-loading-overlay>
<form id="form" name="form" class="form" [formGroup]="formGroup">
    <div class="row mt-5">
        <div class="col">
            <h5>Dados Economia de Energia</h5>
        </div>
    </div> 

    <ng-container *ngIf="respostasQuestionario">
        <div formArrayName="respostas" *ngFor="let respostaControl of respostasQuestionario.controls; let i = index" class="box-pergunta">    
            <div [hidden]="esconderPerguntaPorTipoTomador(listaPerguntas[i])">                 
                <ng-container *ngIf="!listaPerguntas[i].grupo && !ehPerguntaTecnica(listaPerguntas[i])">
                    <div class="row">
                        <div class="bn-form-group col-md-12">
                            <span class="titulo-pergunta">
                                {{listaPerguntas[i].ordem}} )
                                <span [innerHTML]="listaPerguntas[i].frontTitulo"></span>
                            </span>
                            <br/>                                
                            <span class="subtitulo-pergunta" [innerHTML]="listaPerguntas[i].frontSubtitulo"></span>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="listaPerguntas[i].grupo && listaPerguntas[i].frontIsPerguntaNovoGrupo && exibeQuestoes">
                    <div class="row">
                        <div class="bn-form-group col-md-12">
                            <span class="titulo-pergunta">
                                {{listaPerguntas[i].grupo.ordem}} )
                                <span [innerHTML]="listaPerguntas[i].grupo.frontTitulo"></span>
                            </span>
                            <br/>
                            <span class="subtitulo-pergunta" [innerHTML]="listaPerguntas[i].grupo.frontSubtitulo"></span>          
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="listaPerguntas[i].grupo && exibeQuestoes">
                    <div class="row col-md-12">
                        <label class="form-label label-pergunta-grupo">
                            <span [innerHTML]="listaPerguntas[i].frontSubtitulo"></span>                        
                        </label>                            
                    </div>
                </ng-container>
                <div *ngIf="exibeQuestoes || exibePerguntaTecnica(listaPerguntas[i])" [formGroupName]="i">
                    <div class="row">
                        <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'radio' && exibePerguntasTecnicas && ehPerguntaTecnica(listaPerguntas[i])">
                            <div *ngFor="let opcaoResposta of listaPerguntas[i].listaOpcoes" class="bn-form-group col-md-12">
                                    <label class="form-label label-resposta">
                                        <input  
                                            type="radio" 
                                            formControlName="resposta" 
                                            [value]="opcaoResposta.id" 
                                            (change)="trocarSelecao()"
                                            id="{{'radio'+ opcaoResposta.id}}">
                                            {{opcaoResposta.texto}}                    
                                    </label>
                            </div>        
                        </ng-container>
                        <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'radio' && exibeQuestoes && !ehPerguntaTecnica(listaPerguntas[i])">
                            <div *ngFor="let opcaoResposta of listaPerguntas[i].listaOpcoes" class="bn-form-group col-md-12">
                                    <label class="form-label label-resposta">
                                        <input  
                                            type="radio" 
                                            formControlName="resposta" 
                                            [value]="opcaoResposta.id" 
                                            id="{{'radio'+ opcaoResposta.id}}">
                                            {{opcaoResposta.texto}}                    
                                    </label>
                            </div>        
                        </ng-container>
                    </div>
                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'checkbox'">
                        <div class="row">
                            <div formArrayName="resposta">
                                <div *ngFor="let opcaoResposta of listaPerguntas[i].listaOpcoes;let j = index" class="bn-form-group col-md-12">
                                    <label class="form-label label-resposta">
                                        <input  type="checkbox" [formControlName]="j" 
                                            [value]="opcaoResposta.id" id="{{'checkbox'+ opcaoResposta.id}}"
                                            (change)="checkboxChange($event, opcaoResposta, listaPerguntas[i].id)">                                
                                    {{opcaoResposta.texto}}                    
                                    </label>                                    
                                </div>
                            </div> 
                        </div>
                        <div *ngIf="listaPerguntas[i].frontMostrarTextoComplementar">
                            <div class="row">
                                <div class="col-md-6">
                                    <input  type="text" formControlName="textoComplementar" class="form-control text-resposta" 
                                        id="{{'text'+ listaPerguntas[i].id}}">    
                                </div>
                            </div>
                        </div>                            
                    </ng-container>
                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'text'">
                        <div class="row">
                            <div class="bn-form-group {{getClassTamanhoPergunta(listaPerguntas[i])}}">    
                                <input  type="text" formControlName="resposta" class="form-control text-resposta" 
                                    id="{{'text'+ listaPerguntas[i].id}}" bnMask="{{getMascaraPergunta(listaPerguntas[i].tipoValor)}}"
                                    casasDecimais="2"
                                    *ngIf="getMascaraPergunta(listaPerguntas[i].tipoValor)">
                                <input  type="text" formControlName="resposta" class="form-control text-resposta" 
                                    id="{{'text'+ listaPerguntas[i].id}}" 
                                    *ngIf="!getMascaraPergunta(listaPerguntas[i].tipoValor)">                                    
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'date'">
                            <div class="bn-form-group {{getClassTamanhoPergunta(listaPerguntas[i])}}">
                                <bn-datepicker formControlName="resposta">
                                </bn-datepicker>
                            </div>
                    </ng-container>
                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'custom'">
                        <ng-container *ngIf="listaPerguntas[i].frontCustomTemplate">
                            <ng-container *ngTemplateOutlet="listaPerguntas[i].frontCustomTemplate; context: {fg: respostasQuestionario.controls[i] }">
                            </ng-container> 
                        </ng-container> 
                    </ng-container>            
                </div>
            </div>
        </div>     
    </ng-container>   
    
</form>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>    
</div>
